module.exports = __webpack_public_path__ + "img/uberrescue.9e4176e7.svg";